import * as React from 'react';

import * as Errors from './Shared/Constants/Errors';
import isVersionAtLeast from './Shared/Util/isVersionAtLeast';

const MIN_VERSION_REACT = '16.8.3';

if (!isVersionAtLeast(React.version, MIN_VERSION_REACT)) {
    console.warn(Errors.REACT_VERSION_UNSUPPORTED(MIN_VERSION_REACT));
}

export {default as ActionType} from './Actions/Constants/ActionType';
export {default as Alignment} from './Tree/Constants/Alignment';
export {default as createFocusManager} from './FocusManager/createFocusManager';
export {default as focusable} from './Bindings/React/Components/focusable';
export {default as FocusableEvent} from './Events/FocusableEvent';
export {default as FocusableEventType} from './Events/Constants/FocusableEventType';
export {default as FocusableNode} from './Tree/FocusableNode';
export {default as FocusableNodeType} from './Tree/Constants/FocusableNodeType';
export {default as FocusManagerContext} from './Bindings/React/Contexts/FocusManagerContext';
export {default as FocusableProvider} from './Bindings/React/Providers/FocusableProvider';
export {default as FocusManagerFacade} from './FocusManager/FocusManagerFacade';
export {default as Grid} from './Bindings/React/Components/Grid';
export type {default as THandler} from './Shared/Types/THandler';
export {default as HorizontalList} from './Bindings/React/Components/HorizontalList';
export type {default as IEventDetailFocusWillChange} from './Events/Interfaces/IEventDetailFocusWillChangeDetail';
export type {default as IFocusableComponentInjectedProps} from './Bindings/React/Components/Interfaces/IFocusableComponentInjectedProps';
export type {default as IFocusableComponentOptions} from './Bindings/React/Components/Interfaces/IFocusableComponentOptions';
export {default as useFocus} from './Bindings/React/Hooks/useFocus';
export {default as VerticalList} from './Bindings/React/Components/VerticalList';
export {default as VirtualHorizontalList} from './Bindings/React/Components/VirtualHorizontalList';
export {default as VirtualVerticalList} from './Bindings/React/Components/VirtualVerticalList';
export {default as renderReact} from './Shared/Util/renderReact';
